import styled from 'styled-components';

export default styled.div`
  margin-bottom: 20px;

  &:last-of-type {
    margin: 0;
  }

  h3 {
    font-size: 12px;
    color: #869096;
    margin: 0 0 5px 0;
  }

  .note-content {
    display: flex;
    align-items: center;

    p {
      margin: 0;
      font-size: 13px;
      color: #32383e;
    }

    .anticon-copy {
      font-size: 12px;
      top: -1px;
    }
  }
`;
